
import BaseModel from "./BaseModel";

export default class SiteCollectionMapping extends BaseModel {
    static data_name = "site_collection_mappings";
}
